import { Link } from 'react-router-dom';

const serviceLinks = [
  { name: 'Pool Leak Detection', slug: 'pool-leak-detection-las-vegas' },
  { name: 'Water Leak Detection', slug: 'water-leak-detection-las-vegas' },
  { name: 'Slab Leak Repair', slug: 'slab-leak-repair-las-vegas' },
  { name: 'Home Repiping', slug: 'home-repiping-las-vegas' },
  { name: 'Mainline Replacement', slug: 'mainline-replacement-las-vegas' },
  { name: 'Emergency Plumbing', slug: 'emergency-plumbing-las-vegas' },
  { name: 'Water Heater Installation', slug: 'water-heater-installation-las-vegas' },
  { name: 'Water Filtration / Softener', slug: 'water-filtration-softener-las-vegas' },
  { name: 'Garbage Disposal Repair', slug: 'garbage-disposal-repair-las-vegas' },
  { name: 'Water Damage Restoration', slug: 'water-damage-restoration-las-vegas' },
  { name: 'Sewer Line Repair', slug: 'sewer-line-repair-las-vegas' },
  { name: 'Drain Cleaning', slug: 'drain-cleaning-las-vegas' },
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-[#0a1628] to-[#162447] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 mb-10 sm:mb-12">
          {/* Logo and Description */}
          <div className="text-center sm:text-left lg:col-span-1">
            <div className="flex items-center justify-center sm:justify-start gap-2 mb-4">
              <img
                src="https://static.readdy.ai/image/2f42848ae1d54308b2a19bc5b9c28bfc/52b6caa0ebdf1095639a765358c6ba7e.png"
                alt="Leak Detectives Logo"
                className="h-16 w-auto object-contain"
                style={{ filter: 'brightness(0) invert(1)' }}
              />
            </div>
            <p className="text-gray-300 text-sm leading-relaxed mb-4">
              Your trusted partner for professional leak detection and plumbing services in Las Vegas and Clark County.
            </p>
            <div className="flex items-center gap-2 justify-center sm:justify-start">
              <div className="flex gap-0.5">
                {[1,2,3,4,5].map(s => (
                  <i key={s} className="ri-star-fill text-yellow-400 text-sm"></i>
                ))}
              </div>
              <span className="text-gray-300 text-xs">5.0 • 22+ Google Reviews</span>
            </div>
          </div>

          {/* Services - Two columns */}
          <div className="sm:col-span-2 lg:col-span-2">
            <h3 className="text-lg font-black mb-4 text-center sm:text-left">Our Services</h3>
            <div className="grid grid-cols-2 gap-x-4 gap-y-2">
              {serviceLinks.map((s) => (
                <Link
                  key={s.slug}
                  to={`/${s.slug}`}
                  className="text-gray-300 hover:text-cyan-400 transition-colors text-sm flex items-center gap-1"
                >
                  <i className="ri-arrow-right-s-line text-cyan-500 flex-shrink-0"></i>
                  <span>{s.name}</span>
                </Link>
              ))}
            </div>
          </div>

          {/* Contact Info */}
          <div className="text-center sm:text-left">
            <h3 className="text-lg font-black mb-4">Contact Info</h3>
            <div className="space-y-3">
              <div className="flex items-start justify-center sm:justify-start gap-3">
                <i className="ri-phone-fill text-cyan-400 text-xl mt-0.5 flex-shrink-0"></i>
                <div>
                  <p className="text-gray-400 text-xs mb-0.5">Call Us 24/7</p>
                  <a
                    href="tel:7252675482"
                    className="text-white hover:text-cyan-400 font-bold text-base transition-colors"
                  >
                    (725) 267-5482
                  </a>
                </div>
              </div>
              <div className="flex items-start justify-center sm:justify-start gap-3">
                <i className="ri-map-pin-fill text-cyan-400 text-xl mt-0.5 flex-shrink-0"></i>
                <div>
                  <p className="text-gray-400 text-xs mb-0.5">Service Area</p>
                  <p className="text-white text-sm">Las Vegas, NV &amp; Clark County</p>
                </div>
              </div>
              <div className="flex items-start justify-center sm:justify-start gap-3">
                <i className="ri-time-fill text-cyan-400 text-xl mt-0.5 flex-shrink-0"></i>
                <div>
                  <p className="text-gray-400 text-xs mb-0.5">Hours</p>
                  <p className="text-white text-sm font-semibold">24/7 Emergency Service</p>
                </div>
              </div>
            </div>

            {/* Emergency CTA */}
            <div className="mt-5">
              <a
                href="tel:7252675482"
                className="flex items-center justify-center gap-2 bg-red-600 text-white px-4 py-3 rounded-lg font-bold text-sm hover:bg-red-500 transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-fill"></i> Call Now — Emergency
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-700">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-center sm:text-left">
            <p className="text-gray-400 text-xs">
              &copy; {currentYear} Leak Detectives Las Vegas. All rights reserved. Licensed &amp; Insured.
            </p>
            <div className="flex flex-wrap justify-center sm:justify-end gap-4">
              <Link to="/privacy-policy" className="text-gray-400 hover:text-cyan-400 text-xs transition-colors">Privacy Policy</Link>
              <Link to="/terms-of-service" className="text-gray-400 hover:text-cyan-400 text-xs transition-colors">Terms of Service</Link>
              <a href="#" className="text-gray-400 hover:text-cyan-400 text-xs transition-colors">Sitemap</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
